import styled, { css } from 'styled-components'

import { ButtonUnstyled, Text, Dropdown } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'

export const Container = styled.div`
  flex: 1;
  /* stylelint-disable-next-line scales/space */
  padding: 2px 0;

  ${breakpoint('sm')`
      padding: 8px 0; /* stylelint-disable-line scales/space */
  `};
`

export const Trigger = styled(ButtonUnstyled)(
  ({ theme, disabled }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-radius: ${theme.radii.large};
    height: 28px;
    padding: 0 4px 0 8px;

    &:hover {
      background-color: ${disabled ? undefined : theme.colors.state.hover};
    }

    &:active {
      background-color: ${disabled
        ? undefined
        : theme.colors.buttons.pageSelector.active};
    }
  `
)

export const CurrentPage = styled(Text.Div).attrs({
  textStyle: 'copy.primary.standard.D',
})`
  display: block;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 50vw;

  margin-right: 4px;

  em {
    font-style: normal;
    color: ${props => props.theme.colors.foreground.secondary.D};
  }
`

export const Chevrons = styled(Dropdown.Chevrons)`
  color: ${props => props.theme.colors.foreground.secondary.D};
  flex-shrink: 0;
`
